// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kds-table-reference {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  min-width: 0;
  vertical-align: middle;
}

.kds-table-reference__identifier {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  white-space: nowrap;
  padding: 3px 8px;
  border: 1px solid #183c4a;
  border-radius: 5px;
  background: #183c4a;
  color: #fff;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  font-weight: 750;
  line-height: 1.25;
  letter-spacing: 0.025em;
}

.kds-table-reference__prefix {
  font-size: calc(10px + var(--kds-font-delta, 0px));
  font-weight: 650;
  letter-spacing: 0.035em;
  opacity: 0.82;
}

.kds-table-reference__layout {
  min-width: 0;
  overflow: hidden;
  color: #596875;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 500;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dark .kds-table-reference__identifier {
  border-color: #d7e7e9;
  background: #d7e7e9;
  color: #142d36;
}

.dark .kds-table-reference__layout {
  color: #b3c2c8;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/KdsTableReference.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".kds-table-reference {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  max-width: 100%;\n  min-width: 0;\n  vertical-align: middle;\n}\n\n.kds-table-reference__identifier {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex: 0 0 auto;\n  white-space: nowrap;\n  padding: 3px 8px;\n  border: 1px solid #183c4a;\n  border-radius: 5px;\n  background: #183c4a;\n  color: #fff;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  font-weight: 750;\n  line-height: 1.25;\n  letter-spacing: 0.025em;\n}\n\n.kds-table-reference__prefix {\n  font-size: calc(10px + var(--kds-font-delta, 0px));\n  font-weight: 650;\n  letter-spacing: 0.035em;\n  opacity: 0.82;\n}\n\n.kds-table-reference__layout {\n  min-width: 0;\n  overflow: hidden;\n  color: #596875;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dark .kds-table-reference__identifier {\n  border-color: #d7e7e9;\n  background: #d7e7e9;\n  color: #142d36;\n}\n\n.dark .kds-table-reference__layout {\n  color: #b3c2c8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
